/**
 * Copyright (C) Siemens AG 1996-2024 ALL RIGHTS RESERVED.
 */

import {
  AfterContentChecked,
  ChangeDetectorRef,
  Component,
  inject,
} from '@angular/core';
import {ModalService} from '@siemens/ix-angular';
import {ModalCreateBatteryPassComponent} from '../modal-create-battery-pass/modal-create-battery-pass.component';

@Component({
  selector: 'app-battery-pass-ecosystem',
  templateUrl: './battery-pass-ecosystem.component.html',
  styleUrl: './battery-pass-ecosystem.component.scss',
  standalone: false,
})
export class BatteryPassEcosystemComponent implements AfterContentChecked {
  private readonly modalService = inject(ModalService);
  private readonly changeDetector = inject(ChangeDetectorRef);

  ngAfterContentChecked() {
    this.changeDetector.detectChanges();
  }

  async addNewPassportClick() {
    await this.modalService.open({
      size: '840',
      content: ModalCreateBatteryPassComponent,
      centered: true,
      closeOnBackdropClick: true,
    });
  }
}
